/* eslint-disable */
import { Sniff, getLogDate } from './q_sniff'
import qFetch, { getLogParamsFromUrl } from './qFetch'
import { getStorge, saveStorge, removeStorge, getFromForLog } from './q_business'
import { isPlainObject } from 'lodash'
// 允许缓存的日志最大数量
const LOG_MAX_CACHE_COUNT = 1
const { curPage, curPageId, refPage, refPageId, fromForLog } = getLogParamsFromUrl()
const { uid = '', vid = '', model = '' } = Sniff.bnb_tujia || {}
const { lat = '', lng = '' } = getStorge('my_location') || {}
const getUserID = () => {return (Sniff.uinfo && Sniff.uinfo.uid) || ''}
const deviceInfo = {
  appVersion: vid, // vid
  model: model, // 设备型号 iphone6,1
  deviceID: uid, // uid
  source: Sniff.qunar ? 'app' : 'touch', // app/www/touch
  platform: Sniff.ios ? 'ios' : 'adr',
  osVersion: Sniff.osVersion, // 操作系统版本
  userID: getUserID(),
  networkType: Sniff.networkType // 运营商 网络类型
}
const logData = {
  logVersion: '2.3',
  commonParams: {
    ...deviceInfo,
    lat: lat || '',
    lng: lng || ''
  },
  userActions: []
}

// 检查参数是否是对象，否则返回一个空对象
function _isObject(data) {
  return data && isPlainObject(data) ? data : {}
}

function sendLog(payload) {
  const { actPos = '', actText = '', actInfo = '', extraParams, actPage = '', appointedPageParams } = payload || {}
  const actItemOtherInfo = actInfo && typeof actInfo === 'object' ? JSON.stringify(actInfo) : actInfo
  // 扩展参数，允许调用者自定义其他字段
  const extraActionParams = _isObject(extraParams)
  const actionData = {
    refer: refPageId,
    logid: curPageId,
    refPage: refPage,
    actPage: actPage,
    actTime: getLogDate(),
    actPlace: `${lat},${lng}`,
    un: Sniff.getCookieUn(),
    // 点击行为发生的位置。如果同一页面下有多个列表，可采用“列表间编号-列表内编号”的级联形式
    actPos: actPos,
    actItemText: actText,
    actItemOtherInfo,
    fromForLog: getFromForLog(),
    ...extraActionParams
  }
  const userActions = getStorge('action_log') || []
  userActions.push(actionData)
  // 超出最大限制，发送当前缓存日志，并清空缓存
  if (userActions.length >= LOG_MAX_CACHE_COUNT) {
    // 下一个事件循环再发送日志，避免阻塞页面当前其他操作
    setTimeout(() => {
      fetchLog(userActions)
    }, 0)
    removeStorge('action_log')
    return
  }
  saveStorge('action_log', userActions)
}

const fetchLog = (userActions = [], type = 'click') => {
  const logParams = {
    ...logData,
    userActions
  }
  logParams.commonParams.userID = getUserID()
  const logType = type === 'pv' ? 'displayLog' : 'actionLog'
  qFetch({
    url: '/tjbnb/app/log/logfront',
    data: {
      logType,
      logContent: JSON.stringify(logParams)
    }
  })
    .then((res) => {})
    .catch((err) => {})
}

function recordPv(appointedParams, options) {
  // 数据校验
  const appointedPageParams = _isObject(appointedParams)
  const extraParams = _isObject(options)

  const { curPage, curPageId, refPage, refPageId, fromForLog } = Object.assign({}, getLogParamsFromUrl(), appointedPageParams)

  const actionData = {
    refer: refPageId,
    logid: curPageId,
    refPage: refPage,
    actPage: curPage,
    actTime: getLogDate(),
    actPlace: `${lat},${lng}`,
    actPos: '-1',
    fromForLog: getFromForLog(),
    ...extraParams
  }
  // 将pv日志以点击日志的格式记录发送
  const userActions = getStorge('action_log') || []
  userActions.push(actionData)
  saveStorge('action_log', userActions)
  fetchLog([actionData], 'pv')
}

export default sendLog
export { recordPv }
